import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Video2DefaultImageAttributes } from "../../optics";
const _ColItem2VideoAttribute = Fold.compose(Optics._ColItem2Video, Optics._Video2Attributes);
export const _ShowName = Fold.compose(Optics._Show2Attributes, Lens.prop("name"));
export const _Video2ShowName = Fold.pre(Fold.compose(Optics._ColItem2Video, Res._Rel("show"), Fold.map((name) => name, _ShowName)));
export const _Video2Count = Fold.pre(Fold.compose(Optics._ColItem2Video, Res._Rel("season"), Res._Response(), Lens.path("attributes", "videoCount"), M._Just()));
export const _Video2Route = Fold.pre(Fold.compose(Optics._ColItem2Video, Optics._Video2Routes, Optics._Route2AttributesFiltered({ canonical: true }), Lens.prop("url")));
export const _Video2Image = Fold.pre(Fold.compose(Optics._ColItem2Video, _Video2DefaultImageAttributes));
export const _VideoDetailsProps = Fold.compose(Optics._Col2Items, Fold.liftM((attributes, showNameM, videoCountM, routeM, videoImageM, id) => {
    return {
        titleM: M.of(attributes.name),
        showNameM: showNameM,
        isFavoriteM: attributes.isFavorite,
        descriptionM: attributes.description,
        episodeNumberM: attributes.episodeNumber,
        seasonNumberM: attributes.seasonNumber,
        contentRatingM: attributes.contentRatings,
        contentDescriptorsM: attributes.contentDescriptors,
        videoTypeM: attributes.videoType,
        audioTracksM: attributes.audioTracks,
        packagesM: attributes.packages,
        minimumAgeM: attributes.minimumAge,
        videoCountM,
        routeM,
        videoImageM,
        id,
        broadcastType: attributes.broadcastType,
        alternateId: attributes.alternateId,
    };
}, _ColItem2VideoAttribute, _Video2ShowName, _Video2Count, _Video2Route, _Video2Image, Fold.compose(Optics._ColItem2Video, Optics._Video2Data, Lens.prop("id"))));
export const _Video2Genre = Fold.compose(Optics._Col2Items, Optics._ColItem2Video, Optics._Video2TxGenres, Res._Response(), Lens.path("attributes", "name"));
export const _VideoDetails = Fold.compose(Optics._VideoResponseGetter, Optics._Response2ResponseData(), Fold.liftM((attributes, showNameM, videoCountM, routeM, videoImageM, id) => {
    return {
        titleM: M.of(attributes.name),
        showNameM: showNameM,
        isFavoriteM: attributes.isFavorite,
        descriptionM: attributes.description,
        episodeNumberM: attributes.episodeNumber,
        seasonNumberM: attributes.seasonNumber,
        videoTypeM: attributes.videoType,
        audioTracksM: attributes.audioTracks,
        packagesM: attributes.packages,
        minimumAgeM: attributes.minimumAge,
        contentRatingM: attributes.contentRatings,
        contentDescriptorsM: attributes.contentDescriptors,
        videoCountM,
        routeM,
        videoImageM,
        id,
        alternateId: attributes.alternateId,
    };
}, Optics._Video2Attributes, Fold.pre(Fold.compose(Res._Rel("show"), Fold.map((name) => name, _ShowName))), Fold.pre(Fold.compose(Res._Rel("season"), Res._Response(), Lens.path("attributes", "videoCount"), M._Just())), Fold.pre(Fold.compose(Optics._Video2Routes, Res._Response(), Lens.path("attributes", "url"))), Fold.pre(_Video2DefaultImageAttributes), Fold.compose(Res._Response(), Lens.prop("id"))));
export const _PrimaryChannelTitleVideo = Fold.compose(Optics._Col2Items, Res._Rel("video"), Optics._Video2PrimaryChannel, Res._Response(), Lens.path("attributes", "name"));

